import { lookupEnableChatInServerMap } from '../api/gatewayProjectEnableChat';

/**
 * Per-module AI Chat visibility from project settings (`moduleInfo[].enableChat`).
 * Unmapped routes (`moduleKey` null/empty) do not apply module gating.
 * A resolved module shows chat only when its server flag is exactly true.
 * An explicit false or a missing entry hides the assistant.
 *
 * @param {string|null|undefined} projectId
 * @param {string|null|undefined} moduleKey
 * @param {Record<string, boolean>|undefined} serverModuleMap — from API `moduleInfo`
 * @returns {boolean}
 */
export function resolveModuleChatEnabled(
  projectId,
  moduleKey,
  serverModuleMap,
) {
  if (!projectId || moduleKey == null || moduleKey === '') {
    return true;
  }
  return lookupEnableChatInServerMap(serverModuleMap, moduleKey) === true;
}
